import api from 'utils/api';

export const getListTeacher = async (data) => {
    const response = await api.get('/users', { params: data });
    return response.data;
};

export const getListTeacherDropdown = async (params) => {
    const response = await api.get('/users/dropdown', { params });
    return response.data;
};

export const updateTeacher = async (id, data) => {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
};

export const deleteTeacher = async (data) => {
    const response = await api.delete(`/users`, { data: data });
    return response.data;
};

export const addTeacher = async (data) => {
    const response = await api.post(`/users`, data);
    return response.data;
};

export const uploadTeachers = async (data) => {
    const response = await api.post('/users/import-teacher', data);
    return response.data;
};

export const getTeacher = async (id) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
};
